'use strict';

angular
    .module('webmailWrapper')
    .filter('emailType', function (translationProvider) {
        var emailTypeList = {
            ImapMailbox: translationProvider.instant('EMAIL.MAILBOX-TYPE.IMAP'),
            Forwarder: translationProvider.instant('EMAIL.MAILBOX-TYPE.FORWARDER'),
            ExchangeMailbox: translationProvider.instant('EMAIL.MAILBOX-TYPE.EXCHANGE')
        };

        return function (input) {
            return emailTypeList[input];
        };
    });
